import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";
import { toast } from "react-hot-toast";
import { RequestFiltroContaReceberInadimplenciaDTOPaginado } from "types/request/RequestFiltroContaReceberInadimplenciaDTO";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import { RegistroContaReceberDTO } from "types/dto/RegistroContaReceberDTO";

export const useGetRegistrosContaReceber = (request: RequestFiltroContaReceberInadimplenciaDTOPaginado) => {
  const { showModalSelecionarCobrancas } = useProcessosJudiciaisContext();

  const onError = () => {
    toast.error("Erro ao buscar cobranças");
  };

  const config = {
    staleTime: 1000 * 60 * 5,
    retry: 5,
  };

  return useFetch<Page<RegistroContaReceberDTO>>({
    key: [
      "selecionar-cobrancas-processo-judicial",
      request.unidadeId,
      request.sort,
      request.page,
      request.dataVencimentoInicio,
      request.dataVencimentoFim,
    ],
    url: api.contaReceber.getRegistrosPaginados,
    params: request,
    enabled:
      request.unidadeId !== undefined &&
      request.dataVencimentoInicio != null &&
      request.dataVencimentoFim != null &&
      showModalSelecionarCobrancas,
    config,
    onError,
  });
};
